import styled from 'styled-components';

export const Container = styled.div`
  min-height: 700px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
`;

export const Wrapper = styled.div`
  height: ${(props) => (props.isMobile ? 'auto' : '100%')};
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StyleH3 = styled.h3`
  font-size: 20px;
  font-weight: bold;
  color: #10141c;
`;

export const NomalFont = styled.p`
  font-size: 20px;
  font-weight: normal;
  color: #10141c;
`;

export const NormalWhiteSpan = styled.span`
  font-size: 20px;
  font-weight: normal;
  color: #fff;
`;

export const WtNomalSpan = styled.span`
  font-size: 18px;
  font-weight: normal;
  color: #fff;

  @media all and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const StyleH1 = styled.h1`
  font-size: 26px;
  font-weight: bold;
  color: #10141c;

  @media all and (max-width: 1024px) {
    font-size: 18px;
  }

  @media all and (max-width: 480px) {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    font-size: 16px;
  }
`;

export const BdWhiteText = styled.span`
  display: block;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  span {
    font-size: 16px;
  }
  @media all and (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const TitleSubText = styled.p`
  font-size: 20px;
  font-weight: normal;
  color: #fff;
  margin-top: 10px;

  @media all and (max-width: 1024px) {
    margin-top: 20px;
    font-size: 16px;
  }
`;

export const TitleText = styled.p`
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  display: flex;
  align-items: center;
  @media all and (max-width: 1024px) {
    font-size: 16px;
  }
`;
export const MyTicket = styled.p`
  font-size: 18px;
  color: #fff;
  display: flex;
  align-items: center;
  span {
    color: #5affe2;
  }
`;

export const WhiteDot = styled.div`
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #fff;
  border-radius: 50%;
  margin: 0px 10px 5px;
`;
